import { url } from './apiurl';
import { authHeader } from '../_heleper/auth-header';
// Deliberately bypass responseHandler: analytics errors must never log out or block a customer.
export function trackCustomerActivity(type, payload = {}, sessionToken) {
  try {
    const headers = sessionToken ? { Authorization: sessionToken } : authHeader();
    if (!headers.Authorization) return;
    const eventKey = `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 5000);
    fetch(`${url}/auth/customer/activity`, {
      method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, type, eventKey }), signal: controller.signal,
    }).catch(() => {}).finally(() => clearTimeout(timer));
  } catch (error) { /* Analytics cannot interrupt shopping. */ }
}
